import katex from 'katex'

/** 批注回显：转义普通文本，解析 LaTeX 并用 KaTeX 渲染 */
const MATH_RE = /\\\[([\s\S]*?)\\\]|\$\$([\s\S]*?)\$\$|\\\(([\s\S]*?)\\\)/g

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapePlainSegment(text) {
  return escapeHtml(text).replace(/\n/g, '<br>')
}

function renderLatex(latex, displayMode) {
  const trimmed = latex.trim()
  if (!trimmed) return ''
  try {
    return katex.renderToString(trimmed, {
      displayMode,
      throwOnError: false,
      strict: 'ignore',
      output: 'html',
    })
  } catch {
    const raw = displayMode ? `\\[${latex}\\]` : `\\(${latex}\\)`
    return escapePlainSegment(raw)
  }
}

export function renderNoteHtml(input) {
  if (input == null || input === '') return ''

  const src = String(input)
  let html = ''
  let lastIndex = 0
  let match

  MATH_RE.lastIndex = 0
  while ((match = MATH_RE.exec(src)) !== null) {
    html += escapePlainSegment(src.slice(lastIndex, match.index))
    if (match[1] !== undefined) {
      html += renderLatex(match[1], true)
    } else if (match[2] !== undefined) {
      html += renderLatex(match[2], true)
    } else if (match[3] !== undefined) {
      html += renderLatex(match[3], false)
    }
    lastIndex = MATH_RE.lastIndex
  }

  html += escapePlainSegment(src.slice(lastIndex))
  return html
}
